export const PermissionLevel = Object.freeze({
  /**
   * Can be either group, client or location level
   */
  GROUP_AND_BELOW: 'group_and_below',
  /**
   * Permissions for strictly the group level
   */
  GROUP: 'group',
  /**
   * Can be either client or location level
   */
  CLIENT_AND_BELOW: 'client_and_below',
  /**
   * Permissions for strictly the client level
   */
  CLIENT: 'client',
  /**
   * Can be either the currently selected client or one of the client's locations
   */
  SELECTED_CLIENT_AND_BELOW: 'selected_client_and_below',
  /**
   * Permissions for strictly the selected client
   */
  SELECTED_CLIENT: 'selected_client',
  /**
   * Permissions for strictly the location level
   */
  LOCATION: 'location',
})
